document.addEventListener('DOMContentLoaded', () => {
    const DURATION = 1000; // total animation duration in ms
  
    const animateCountUp = (el, targetNumber, duration = DURATION) => {
      const start = 0;
      const startTime = performance.now();
  
      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const currentValue = Math.floor(progress * targetNumber);
        el.innerHTML = `${currentValue}<span class="h4">%</span>`
        
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          // Ensure exact final value
          el.innerHTML = `${targetNumber}<span class="h4">%</span>`;
        }
      };
  
      requestAnimationFrame(update);
    };
  
    const handleIntersection = (entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const el = entry.target;
          const maxNumber = parseInt(el.getAttribute('data-max-number'), 10);
          if (!isNaN(maxNumber)) {
            animateCountUp(el, maxNumber);
          }
          observer.unobserve(el);
        }
      }
    };
  
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0.8 // triggers when at least 10% of element is visible
    });

    const resultLines = document.querySelectorAll('.result-line__number');
  
    if(!resultLines) return;

    // Observe all existing .result-line__number elements
    resultLines.forEach(el => {
      observer.observe(el);
    });
  
    // Set up a mutation observer to watch for newly added .result-line__number elements
    const mutationObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches?.('.result-line__number')) {
              observer.observe(node);
            } else if (node.nodeType === 1 && node.querySelectorAll) {
              // If a container node is added, it might contain multiple .result-line__number elements
              node.querySelectorAll('.result-line__number').forEach(el => {
                observer.observe(el);
              });
            }
          });
        }
      }
    });
  
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  });
  